import { HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { COMMON_CONSTANTS } from '../common/core/common.constants';
import { APIGEE_TOKEN_URL } from '../common/core/urls.constants';
import { HelperUtilityService } from './helper-utility.service';
@Injectable({
  providedIn: 'root',
})
export class ApigeeTokenService {
  public accessToken: any = '';
  caller: number;
  orgId: any;

  constructor(
    private _helperUtilSvc: HelperUtilityService) {
  }

  _accessTokenSubscriber: Subscription;



  setRequestHeaders(req: HttpRequest<any>): HttpHeaders {

    const headerSettings: { [name: string]: string | string[]; } = {};
      if (req.headers.keys.name !== "") {
      for (const key of req.headers.keys()) {
       headerSettings[key] = req.headers.getAll(key);
   }

    }


    const urlSplit = req.url.split(/[.\_/?=]/);

   if(req.url === COMMON_CONSTANTS.EVALUATE_PROMO_URL || urlSplit.includes(COMMON_CONSTANTS.DOCUMENTS_ID_URL) ||
   urlSplit.includes(COMMON_CONSTANTS.PAYMENT_DETAILS_URL)){
    headerSettings[COMMON_CONSTANTS.HEADER_PROPERTIES.B2B_CLIENT_KEY] = COMMON_CONSTANTS.HEADER_PROPERTIES.B2B_CLIENT_ID_TFB_AM_APP;
   }else{
    headerSettings[COMMON_CONSTANTS.HEADER_PROPERTIES.B2B_CLIENT_KEY] = headerSettings[COMMON_CONSTANTS.HEADER_PROPERTIES.B2B_CLIENT_KEY] ?
    headerSettings[COMMON_CONSTANTS.HEADER_PROPERTIES.B2B_CLIENT_KEY] : this._helperUtilSvc.getClientId();
   }

    headerSettings[COMMON_CONSTANTS.HEADER_PROPERTIES.B2B_ORG_KEY] = headerSettings[COMMON_CONSTANTS.HEADER_PROPERTIES.B2B_ORG_KEY] ?
      headerSettings[COMMON_CONSTANTS.HEADER_PROPERTIES.B2B_ORG_KEY] : this._helperUtilSvc.getOrgID();
    headerSettings[COMMON_CONSTANTS.HEADER_PROPERTIES.B2B_USERID_KEY] = this._helperUtilSvc.getUserId();
    headerSettings[COMMON_CONSTANTS.HEADER_PROPERTIES.B2B_CCID_KEY] = this._helperUtilSvc.getOrgID();
    headerSettings[COMMON_CONSTANTS.HEADER_PROPERTIES.AUTH_TYPE] = this._helperUtilSvc.getAuthType();
    headerSettings[COMMON_CONSTANTS.TRANSACTIONID] = this._helperUtilSvc.getTransactionID();
  this.setHeadersForApi(req,headerSettings);

      headerSettings[COMMON_CONSTANTS.HEADER_PROPERTIES.AUTH_TOKEN] = this._helperUtilSvc.getAuthToken();


    return new HttpHeaders(headerSettings);
  }

  setHeadersForApi(req,headerSettings){
    if (!(req.url.includes(APIGEE_TOKEN_URL.APIGEE_VERIFY_AFFILIATION_DOCUMENTS.path))) {
      if (req.url.indexOf(APIGEE_TOKEN_URL.SPLUNK_LOG.path) == -1) {
        headerSettings[COMMON_CONSTANTS.HEADER_PROPERTIES.CONTENT_TYPE_KEY] = req.headers.get(COMMON_CONSTANTS.HEADER_PROPERTIES.CONTENT_TYPE_KEY) ? req.headers.get(COMMON_CONSTANTS.HEADER_PROPERTIES.CONTENT_TYPE_KEY) : COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY;
      } else {
        headerSettings[COMMON_CONSTANTS.HEADER_PROPERTIES.CONTENT_TYPE_KEY] = COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY;
      }
    }
  }
}
